import DefaultPayManage from './main';
export default DefaultPayManage;
